<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card(min-height="80vh")
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic100}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic800--text Add product
        v-card-text.pa-0
          .products
            .background-header
              v-container.white.pb-1(style="max-width:600px")
                div.my-2.mx-2
                  v-text-field(v-model="searchText" placeholder='Search product' hide-details dense outlined height="40" background-color="basic200")
                    template(v-slot:append)
                      eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
                div.my-2.mx-2
                  v-btn.s1.text-capitalize.px-0(color="textColorAccent" text @click="clickAddProduct")
                    eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="20" height="20" style="margin-top: 3px")
                    | create new product
              v-container.pa-0.mb-4(style="max-width:600px")
                v-layout.my-6(v-if="isFetching")
                  v-row.fill-height.ma-0(align='center' justify='center')
                    v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
                .contain-layout(v-else)
                  v-layout.my-6(v-if="products.length == 0")
                    v-row.fill-height.ma-0(align='center' justify='center')
                      div.mx-auto
                        v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                        p.caption Products not found or empty
                  .items-layout.mx-2(v-else)
                    v-divider.basic300
                    template(v-for='(product, index) in products')
                      v-row(no-gutters @click="addProduct(product)")
                        v-col.py-1.shrink
                          v-img.ma-2(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" width="56px" aspect-ratio="1")
                        v-col.py-3.pr-2.pr-2
                          .product-title.p1.basic800--text.mb-1 {{ product.name }}
                          .product-description.c1.basic600--text.mb-1(v-html="product.description")
                        v-col.py-3.pr-2.shrink(style="min-width:87px" align="right")
                          .p2.primary400--text {{ product.price | displayPrice }}
                          v-chip.mt-3(v-if="getQuantity(product)" color="info" small)
                            .p2.basic100--text x {{ getQuantity(product) }}
                      v-divider.basic300
                y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")
        v-card-actions.px-4
          .p2 {{ $tc('item', finalProducts.length) }} selected
          v-spacer
          v-btn(color='white', text @click='cancelProducts()')
            .button-Aa-medium.primary400--text Cancel
          v-btn(color='info500' depressed @click="saveProducts()")
            .button-AA-medium.basic100--text {{ $t('confirm') }}

    .product(style="max-width:500px")
      product(v-if="openProduct" :open.sync="openProduct" :product.sync="openingProduct" :selectedProduct.sync="selectedProduct" language="en" :hasDiscountPermission.sync="hasDiscountPermission" @updateItem="handleUpdateItem($event)")

    .productVariants(style="max-width:500px")
      variants(v-if="openVariants" :open.sync="openVariants" :product.sync="vProduct" :inventory.sync="vInventory" language="en" :hasDiscountPermission.sync="hasDiscountPermission" @finalVariants="getVariants($event)")

    .productAddons(style="max-width:500px")
      addons(v-if="openAddons" :open.sync="openAddons" :product="aProduct" :inventory.sync="aInventory" language="en" :hasDiscountPermission.sync="hasDiscountPermission" @finalProdAddon="getProdAddon($event)")

    .modals
      add-product(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :hasDiscountPermission.sync="hasDiscountPermission" @added="handleAddItem")

</template>

<script>
import { mapGetters } from 'vuex'
import queryString from 'query-string'
import AddProduct from '@/components/yezzabook/dialogs/income/addincome/AddProduct.vue'
import ProductItem from '@/components/ProductItem.vue'
import Product from '@/components/forms/Product.vue'
import Variants from '@/components/forms/Variants.vue'
import Addons from '@/components/forms/Addons.vue'
import ShowMoreText from '@/components/ShowMoreText'

export default {
  name: 'addProductsDialog',
  components: { AddProduct, ProductItem, Product, Variants, Addons, ShowMoreText },
  props: ['open', 'initial', 'isEditing'],
  data: () => ({
    showAddProductDialog: false,
    isFetching: false,
    pageSize: 10,
    count: 0,
    page: 1,
    products: [],
    selectedProducts: [],
    searchText: '',
    openProduct: false,
    openVariants: false,
    openAddons: false,
    openingProduct: null,
    selectedProduct: null,
    vProduct: null,
    vInventory: null,
    aProduct: null,
    aInventory: { inv_enable: false, inv_qty: 0 },
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    finalProducts () {
      if (this.isEditing) {
        return this.selectedProducts
      }
      return this.selectedProducts.filter(f => f.quantity > 0)
    },
    hasDiscountPermission () {
      if (!this.$store.state.user.member) {
        return false
      }
      const member = this.$store.state.user.member
      if (member.company.id === this.company.id && member.role === 'Admin') {
        return true
      }
      return false
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchProducts(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        if (this.page === 1) {
          this.fetchProducts(1)
        }
        this.page = 1
      }, 500)
    },
  },
  mounted () {
    this.selectedProducts = [ ...this.initial ]
    this.fetchProducts(1)
  },
  methods: {
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/products/?page=${page}&page_size=${this.pageSize}&company=${this.company.id}&ordering=-id`
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.products = response.data.results
        this.count = response.data.count
      }).catch(() => {})
    },
    handleAddItem (item) {
      this.products.splice(0, 0, item.product)
      this.selectedProducts.push(item)
    },
    clickAddProduct () {
      this.showAddProductDialog = true
    },
    getQuantity (product) {
      let count = 0
      let vary = this.selectedProducts.filter(f => f.product.variant_for === product.id)
      if (vary.length >  0) {
        count = vary.map(m => { return m.quantity }).reduce((total, num) => { return total + num })
        product.variants = [...vary.map(m => { return { id: m.product.id, name: m.name, quantity: m.quantity, price: m.price, discount: m.discount
        , show_discount_as_percentage: m.show_discount_as_percentage }})]
      } else {
        let selprod = this.selectedProducts.filter(f => f.product.id === product.id)
        if (selprod.length > 0) {
          selprod.forEach(o => {
            count += o.quantity
          })
        } else {
          count = 0
        }
      }
      return count
    },
    addProduct (product) {
      if (product.has_variants) {
        this.onVariants(product)
      } else {
        if (product.has_addons) {
          this.onAddons(product)
        } else {
          this.onProduct(product)
        }
      }
    },
    onProduct (val) {
      this.openingProduct = val
      let selprod = this.selectedProducts.filter(f => f.product.id === this.openingProduct.id)
      if (selprod.length > 0) {
        this.selectedProduct = selprod[0]
      } else {
        this.selectedProduct = null
      }
      this.openProduct = true
    },
    onVariants (val) {
      let fvariant = this.selectedProducts.filter(f => f.product.variant_for === val.id)
      if (fvariant.length > 0) {
        let variants = fvariant.map(m => { return { ...m, ...m.product } })
        val.variant_products = variants 
      }
      this.vProduct = { ...val }
      this.vInventory = { inv_enable: val.inventory_enabled, inv_qty: val.inventory_qty }
      this.openVariants = true
    },
    onAddons (val) {
      let faddon = this.selectedProducts.filter(f => f.product.id === val.id)
      faddon.length > 0 ? val.addon_products = faddon : val.addon_products = [{ id: val.id, name: val.name, price: val.price, quantity: 0 }]
      this.aProduct = { ...val }
      this.aInventory = { inv_enable: val.inventory_enabled, inv_qty: val.inventory_qty }
      this.openAddons = true
    },
    handleUpdateItem (val) {
      let selprod = this.selectedProducts.filter(f => f.product.id === val.product.id)
      if (selprod.length > 0) {
        selprod[0].quantity = val.quantity
        selprod[0].discount = val.discount
        selprod[0].show_discount_as_percentage = val.show_discount_as_percentage
      } else {
        this.selectedProducts.push(val)
      }
    },
    getVariants (val) {
      val.variant_products.forEach(o => {
        let a = this.selectedProducts.filter(f => f.product.id === o.id)
        if (a.length > 0) {
          a[0].quantity = o.quantity
          a[0].discount = o.discount || 0
          a[0].show_discount_as_percentage = o.show_discount_as_percentage || false
          a[0].selectedOptions = o.selectedOptions
        } else {
          const newProduct = {
            quantity: o.quantity,
            discount: o.discount || 0,
            show_discount_as_percentage: o.show_discount_as_percentage || false,
            product: { id: o.id, name: o.name, variant_for: val.parent_id, price: o.price },
            selectedOptions: o.selectedOptions
          }
          this.selectedProducts.push(newProduct)
        }
      })
      this.vProduct = {}
    },
    getProdAddon (val) {
      val.addon_products.forEach((o, index) => {
        if (o.product) {
          let selprod = this.selectedProducts.filter(f => f.id && f.id === o.id)
          if (selprod.length > 0) {
            this.$set(selprod[0], 'addons', [...o.addons])
            this.$set(selprod[0], 'quantity', o.quantity)
            this.$set(selprod[0], 'discount', o.discount)
            this.$set(selprod[0], 'show_discount_as_percentage', o.show_discount_as_percentage)
          } else {
            let idx = this.selectedProducts.filter(f => f.temp === index)[0]
            this.$set(idx, 'addons', [...o.addons])
            this.$set(idx, 'quantity', o.quantity)
            this.$set(idx, 'discount', o.discount)
            this.$set(idx, 'show_discount_as_percentage', o.show_discount_as_percentage)
          }
        } else {
          const newProduct = {
            id: null,
            name: o.name,
            price: o.price,
            quantity: o.quantity,
            discount: o.discount,
            show_discount_as_percentage: o.show_discount_as_percentage,
            product: { id: o.id, name: o.name, price: o.price },
            addons: [...o.addons],
            temp: index
          }
          this.selectedProducts.push(newProduct)
        }
      })
      this.aProduct = {}
    },
    cancelProducts () {
      this.selectedProducts = [ ...this.initial ]
      this.showModal = false
    },
    saveProducts () {
      this.$emit("confirm", this.finalProducts)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.product-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "item": "No item | {n} item |  {n} items",
    "cancel": "Cancel",
    "confirm": "Confirm"
  }
}
</i18n>
